/*
 *
 * File JS componente block two images
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";
import "./block-two-images.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//
const blockTwoImages = () => {
    let allBlockTwoImages = document.querySelectorAll(
        ".block-two-images .content-images__slider"
    );

    if (!allBlockTwoImages.length) return;

    allBlockTwoImages.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        let slides = el.querySelectorAll(".swiper-slide");
        let loopActive = true;

        if (slides.length > 1) {
            loopActive = true;
        } else {
            loopActive = false;
        }

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            spaceBetween: 0,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
            loop: loopActive,
            autoplay: {
                delay: 2000,
            },
            watchOverflow: true,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                clickable: false,
                type: typePagination,
                dynamicBullets: false,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default blockTwoImages;

//--------------------------------------------------------------------//
